import type { AxiosRequestConfig } from 'axios';
import { endpoints } from '@/api/endpoints';
import {
  depositResponseSchema,
  getWithdrawalResponseSchema,
  payOverdueResponseSchema,
  withdrawFullAmountResponseSchema,
} from '@/api/paymentProvider/schemas';
import type {
  PendingTransactionResponse,
  SEDepositPayload,
  SEPayOverduePayload,
  UKDepositPayload,
  UKPayOverduePayload,
  WithdrawResponse,
} from '@/api/paymentProvider/types';
import type { ServerResponse } from '@/api/types';
import { apiRequest } from '@/api/utils/api';

export const payExtra = async (payload: SEDepositPayload | UKDepositPayload) => {
  const result = await apiRequest({
    url: '/payment-provider/payment/extra',
    method: 'POST',
    data: payload,
    schema: depositResponseSchema,
  });
  return result.paymentProviderUrl;
};

export const completeLoan = async (payload: SEDepositPayload | UKDepositPayload) => {
  const result = await apiRequest({
    url: '/payment-provider/payment/complete-loan',
    method: 'POST',
    data: payload,
    schema: depositResponseSchema,
  });
  return result.paymentProviderUrl;
};

export const withdraw = (amount: number, config?: AxiosRequestConfig) =>
  apiRequest<WithdrawResponse>({
    url: '/payment-provider/withdrawal',
    method: 'POST',
    data: { amount },
    ...config,
  });

export const withdrawFullAmount = () =>
  apiRequest({
    url: endpoints.paymentProvider.withdrawal.fullAmount,
    method: 'POST',
    schema: withdrawFullAmountResponseSchema,
  });

export const payOverdue = async (payload: SEPayOverduePayload | UKPayOverduePayload) => {
  const result = await apiRequest({
    url: '/payment-provider/payment/overdue',
    method: 'POST',
    data: payload,
    schema: payOverdueResponseSchema,
  });
  return result.paymentProviderUrl;
};

export const getPendingTransaction = async () => {
  const result = await apiRequest<ServerResponse<PendingTransactionResponse>>({
    url: '/payment-provider/pending-transaction',
    method: 'GET',
  });
  return result.data;
};

export const getWithdrawalById = (transactionId: string) =>
  apiRequest({
    url: `/payment-provider/withdrawal/${transactionId}`,
    method: 'GET',
    schema: getWithdrawalResponseSchema,
  });
